import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  FormInput,
  Button,
  FormSelect,
} from "shards-react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import axios from "axios";
import { db, auth, db_reading_stage } from "../../../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { sendPasswordResetEmail } from "firebase/auth";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavLink } from "shards-react";
import { Cloud_API_URL } from "../../../utils/constants";

function SubAdmins() {
  const env = process.env;
  const [admins, setAdmins] = useState([]);
  const [newAdmin, setNewAdmin] = useState({});
  const [newTeacher, setNewTeacher] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [teacherModalVisible, setTeacherModalVisible] = useState(false);
  const [submitBtnState, setSubmitBtnState] = useState(false);
  const [resetModalVisible, setResetModalVisible] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setEmailResetLoading] = useState(false);
  const [resetResponse, setResetResponse] = useState("");
  const AdminsRef = React.useRef(admins);
  const [schools, setSchools] = useState([]); // State for schools
  const [classes, setClasses] = useState({}); // State for classes by school
  const [schoolModalOpen, setSchoolModalOpen] = useState(false);
  const [classModalOpen, setClassModalOpen] = useState(false);
  const [newSchool, setNewSchool] = useState({ name: "", city: "" });
  const [newClass, setNewClass] = useState({ name: "", schoolId: "" });
  const [opticianModalVisible, setOpticianModalVisible] = useState(false);
  const [newOptician, setNewOptician] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    PhoneNumber: "",
  });

  const addOpticianModal = () => setOpticianModalVisible(!opticianModalVisible);

  const createOptician = async () => {
    try {
      if (
        !newOptician.FirstName ||
        !newOptician.LastName ||
        !newOptician.Email
      ) {
        alert("Please fill First Name, Last Name, and Email.");
        return;
      }

      setSubmitBtnState(true);

      const payload = {
        first_name: newOptician.FirstName,
        last_name: newOptician.LastName,
        email: newOptician.Email,
        phone_number: newOptician.PhoneNumber || undefined,
      };

      await axios.post(`${Cloud_API_URL}/optician/create`, payload);

      setSubmitBtnState(false);
      setOpticianModalVisible(false);
      setNewOptician({
        FirstName: "",
        LastName: "",
        Email: "",
        PhoneNumber: "",
      });
      alert("Optician created successfully.");
    } catch (error) {
      setSubmitBtnState(false);
      alert(
        error?.response?.data?.message ||
          error.message ||
          "Failed to create optician."
      );
    }
  };

  // Create a new school
  const handleSaveSchool = async () => {
    const { name, city } = newSchool;

    if (!name || !city) {
      alert("Both name and city are required for a school.");
      return;
    }

    try {
      const response = await axios.post(
        `${Cloud_API_URL}/school/create-school`,
        {
          schoolName: name,
          city,
        }
      );

      setSchools((prev) => [...prev, response.data]); // Update the schools list
      handleSchoolModalClose();
    } catch (error) {
      console.error("Error creating school:", error);
      alert("Failed to create school. Please try again.");
    }
  };

  // Create a new class
  const handleSaveClass = async () => {
    const { name, schoolId } = newClass;

    if (!name || !schoolId) {
      alert("Both class name and associated school are required.");
      return;
    }

    try {
      const response = await axios.post(
        `${Cloud_API_URL}/school/create-class`,
        {
          className: name,
          schoolId: parseInt(schoolId, 10),
        }
      );

      // Update classes for the corresponding school
      setClasses((prev) => ({
        ...prev,
        [schoolId]: [...(prev[schoolId] || []), response.data],
      }));
      handleClassModalClose();
    } catch (error) {
      console.error("Error creating class:", error);
      alert("Failed to create class. Please try again.");
    }
  };
  // Handle input changes for school creation
  const handleSchoolFormChange = (field, value) => {
    setNewSchool((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle input changes for class creation
  const handleClassFormChange = (field, value) => {
    setNewClass((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  // Handlers for School Modal
  const handleSchoolModalOpen = () => setSchoolModalOpen(true);
  const handleSchoolModalClose = () => setSchoolModalOpen(false);

  // Handlers for Class Modal
  const handleClassModalOpen = () => setClassModalOpen(true);
  const handleClassModalClose = () => setClassModalOpen(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "SubAdminData"), (data) => {
      data.docChanges().forEach(async (change) => {
        if (change.type === "added") {
          setAdmins((prevUsers) => [
            ...prevUsers,
            { uid: change.doc.id, ...change.doc.data() },
          ]);
        }
        if (change.type === "modified") {
          let newArray = [...AdminsRef.current];
          let index = newArray.findIndex((user) => change.doc.id === user.uid);
          newArray[index] = { uid: change.doc.id, ...change.doc.data() };
          setAdmins(newArray);
        }
        if (change.type === "removed") {
          let newArray = [...AdminsRef.current];
          let index = newArray.findIndex((user) => change.doc.id === user.uid);
          newArray.splice(index, 1);
          setAdmins(newArray);
        }
      });
    });

    // Fetch schools and classes from the API
    axios
      .get(`${Cloud_API_URL}/school`)
      .then((response) => {
        const { schools } = response.data;
        setSchools(schools);

        // Create a map of schoolId to classes
        const classesMap = schools.reduce((acc, school) => {
          acc[school.id] = school.classes;
          return acc;
        }, {});
        setClasses(classesMap);
      })
      .catch((error) => {
        console.error("There was an error fetching the schools!", error);
      });

    return unsubscribe;
  }, []);

  const emailReport = async (teacherUUID) => {
    axios
      .get(`${Cloud_API_URL}/school/teacher/email-report/${teacherUUID}`)
      .then((response) => {
        alert("Report sent successfully");
      })
      .catch((error) => {
        alert("There was an error sending the report");
      });
  };

  const createSubAdmin = async () => {
    try {
      setSubmitBtnState(true);
      await axios.post(`${Cloud_API_URL}/school/subadmin`, newAdmin);
      setSubmitBtnState(false);
      setModalVisible(!modalVisible);
    } catch (error) {
      setSubmitBtnState(false);
      if (error.response.data.error.code === "auth/email-already-exists") {
        alert(error.response.data.error.message);
      } else {
        alert(error.message);
      }
    }
  };

  const createTeacher = async () => {
    try {
      if (!newTeacher.Role) {
        alert("Please select a role for the teacher.");
        return;
      }

      const teacherData = {
        first_name: newTeacher.FirstName,
        last_name: newTeacher.LastName,
        phone_number: newTeacher.MobileNumber,
        email: newTeacher.Email,
        role: newTeacher.Role,
        schoolId: parseInt(newTeacher.School, 10),
        classId: parseInt(newTeacher.Class, 10),
      };

      setSubmitBtnState(true);

      const res = await axios.post(
        `${Cloud_API_URL}/school/teacher`,
        teacherData
      );

      const apiMsg =
        res && res.data && res.data.message ? String(res.data.message) : "";

      if (apiMsg === "Teacher Already Exists") {
        alert(apiMsg);
        setSubmitBtnState(false); // keep modal open
        return;
      }

      setSubmitBtnState(false);
      setTeacherModalVisible(!teacherModalVisible);
    } catch (error) {
      setSubmitBtnState(false);

      // Extract meaningful server message
      let serverMsg = "";
      if (error && error.response && error.response.data) {
        serverMsg =
          error.response.data.message || error.response.data.error || "";
      }
      if (!serverMsg && error && error.message) {
        serverMsg = error.message;
      }
      if (!serverMsg) serverMsg = "Something went wrong.";

      alert(serverMsg);
    }
  };

  const columns = [
    {
      dataField: "FirstName",
      text: "Full Name",
      sort: true,
      formatter: (cell, row) => {
        return (
          <NavLink
            style={{
              color: "inherit",
              fontSize: "15px",
              fontWeight: 500,
              padding: 0,
            }}
            tag={(props) => <RouteNavLink {...props} />}
            to={`/sub-admin-data/${row.uid}`}
          >
            {`${row.FirstName} ${row.LastName}`}
          </NavLink>
        );
      },
    },
    {
      dataField: "Email",
      sort: true,
      text: "Email",
    },
    {
      isDummyField: true,
      dataField: "",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <>
            <button
              type="button"
              className="btn btn-info"
              style={{ zIndex: 1 }}
              onClick={() => resetPasswordModal(row.Email)}
            >
              Reset Password
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-info"
              onClick={() => emailReport(row.uid)}
            >
              Email Report
            </button>
          </>
        );
      },
    },
    {
      dataField: "StudentsTrainingTracker",
      text: "Students Training Tracker",
      sort: false,
      formatter: (cell, row) => {
        const name = `${row.FirstName} ${row.LastName}`;
        return (
          <NavLink
            className="btn btn-primary w-50"
            tag={(props) => <RouteNavLink {...props} />}
            to={`/sub-admin-students-tracking/${row.uid}/${name}`}
            target="_blank"
          >
            Track students
          </NavLink>
        );
      },
    },
  ];

  const pagination = paginationFactory({
    sizePerPage: 50,
    hideSizePerPage: true,
  });

  const SearchBar = (props) => {
    return (
      <input
        className="form-control"
        type="text"
        onChange={(e) => props.onSearch(e.target.value)}
      />
    );
  };

  const resetPasswordModal = (email) => {
    setResetResponse("");
    setEmailResetLoading(false);
    setResetEmail(email);
    setResetModalVisible(!resetModalVisible);
  };

  const sendResetPasswordLink = async (resetEmail) => {
    try {
      if (resetEmail) {
        setEmailResetLoading(true);
        await axios.post(
          `${Cloud_API_URL}/user/send-reset-password-to-sub-admin`,
          { email: resetEmail }
        );
        setResetResponse("Sent successfully");
      }
    } catch (error) {
      setResetResponse(
        error?.response?.data?.message || "Something went wrong. Try again"
      );
      setEmailResetLoading(false);
    }
  };

  const addSubAdminModal = () => {
    setModalVisible(!modalVisible);
  };

  const addTeacherModal = () => {
    setTeacherModalVisible(!teacherModalVisible);
  };

  const goToRolesTeacherPanel = () => {
    window.open("https://teachers.imvilabs.com/roles/", "_blank", "noopener");
  };

  const goToSchoolsTeacherPanel = () => {
    window.open("https://teachers.imvilabs.com/schools/", "_blank", "noopener");
  };

  return (
    <Container fluid className="main-content-container px-4">
      <Row className="page-header py-4">
        <Col>
          <Card small className="mb-4">
            <CardBody className="p-0 pb-3">
              <ToolkitProvider
                keyField="uid"
                data={admins}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "15px 20px",
                      }}
                    >
                      <h6 className="m-0 font-weight-bold">Sub Admins</h6>
                      <div className="w-45">
                        <SearchBar {...props.searchProps} />
                      </div>
                    </div>
                    <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                      <button
                        className="btn btn-info"
                        onClick={() => goToRolesTeacherPanel()}
                        style={{ marginLeft: "10px" }}
                      >
                        Add Teacher
                      </button>
                      <button
                        className="btn btn-info"
                        onClick={addOpticianModal}
                        style={{ marginLeft: "10px" }}
                      >
                        Add Optician
                      </button>

                      <button
                        className="btn btn-info"
                        onClick={() => goToSchoolsTeacherPanel()}
                        style={{ marginLeft: "10px" }}
                      >
                        Add School
                      </button>
                      <button
                        className="btn btn-info"
                        onClick={() => goToSchoolsTeacherPanel()}
                        style={{ marginLeft: "10px" }}
                      >
                        Add Class
                      </button>
                    </div>

                    <BootstrapTable
                      pagination={pagination}
                      {...props.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Sub Admin Modal */}
      <Modal open={modalVisible} toggle={addSubAdminModal}>
        <ModalHeader>Add Sub Admin</ModalHeader>
        <ModalBody>
          <Form autoComplete={"off"}>
            <Row>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <label htmlFor="#firstName" className="mb-2">
                    First Name
                  </label>
                  <FormInput
                    id="#firstName"
                    placeholder="First Name"
                    type="text"
                    onChange={(e) =>
                      setNewAdmin({ ...newAdmin, first_name: e.target.value })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <label htmlFor="#lastName" className="mb-2">
                    Last Name
                  </label>
                  <FormInput
                    id="#lastName"
                    placeholder="Last Name"
                    type="text"
                    onChange={(e) =>
                      setNewAdmin({ ...newAdmin, last_name: e.target.value })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#email" className="mb-2">
                    Email
                  </label>
                  <FormInput
                    id="#email"
                    placeholder="Email"
                    type="email"
                    autoComplete="off"
                    onChange={(e) =>
                      setNewAdmin({ ...newAdmin, email: e.target.value })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#mobleNumber" className="mb-2">
                    Mobile Number
                  </label>
                  <FormInput
                    id="#mobleNumber"
                    placeholder="Mobile Number"
                    type="text"
                    onChange={(e) =>
                      setNewAdmin({
                        ...newAdmin,
                        phone_number: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button
              theme="success"
              className="submit_button"
              disabled={submitBtnState}
              onClick={() => createSubAdmin()}
            >
              Submit
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      {/* Teacher Modal */}
      <Modal open={teacherModalVisible} toggle={addTeacherModal}>
        <ModalHeader>Add Teacher</ModalHeader>
        <ModalBody>
          <Form autoComplete={"off"}>
            <Row>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <label htmlFor="#teacherFirstName" className="mb-2">
                    First Name
                  </label>
                  <FormInput
                    id="#teacherFirstName"
                    placeholder="First Name"
                    type="text"
                    onChange={(e) =>
                      setNewTeacher({
                        ...newTeacher,
                        FirstName: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <label htmlFor="#teacherLastName" className="mb-2">
                    Last Name
                  </label>
                  <FormInput
                    id="#teacherLastName"
                    placeholder="Last Name"
                    type="text"
                    onChange={(e) =>
                      setNewTeacher({
                        ...newTeacher,
                        LastName: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#teacherEmail" className="mb-2">
                    Email
                  </label>
                  <FormInput
                    id="#teacherEmail"
                    placeholder="Email"
                    type="email"
                    autoComplete="off"
                    onChange={(e) =>
                      setNewTeacher({ ...newTeacher, Email: e.target.value })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#teacherMobileNumber" className="mb-2">
                    Mobile Number
                  </label>
                  <FormInput
                    id="#teacherMobileNumber"
                    placeholder="Mobile Number"
                    type="text"
                    onChange={(e) =>
                      setNewTeacher({
                        ...newTeacher,
                        MobileNumber: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#selectSchool" className="mb-2">
                    Select School
                  </label>
                  <FormSelect
                    id="#selectSchool"
                    onChange={(e) => {
                      const selectedSchool = e.target.value;
                      setNewTeacher({ ...newTeacher, School: selectedSchool });
                      // Clear the previously selected class when the school changes
                      setNewTeacher((prev) => ({ ...prev, Class: "" }));
                    }}
                  >
                    <option value="">Select School</option>
                    {schools.map((school, index) => (
                      <option key={index} value={school.id}>
                        {school.name}
                      </option>
                    ))}
                  </FormSelect>
                </FormGroup>
              </Col>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#selectClass" className="mb-2">
                    Select Class
                  </label>
                  <FormSelect
                    id="#selectClass"
                    onChange={(e) =>
                      setNewTeacher({ ...newTeacher, Class: e.target.value })
                    }
                    disabled={!newTeacher.School} // Disable if no school is selected
                  >
                    <option value="">Select Class</option>
                    {newTeacher.School &&
                      classes[newTeacher.School] &&
                      classes[newTeacher.School].map((cls, index) => (
                        <option key={index} value={cls.id}>
                          {cls.name}
                        </option>
                      ))}
                  </FormSelect>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#selectRole" className="mb-2">
                    Select Role
                  </label>
                  <FormSelect
                    id="#selectRole"
                    onChange={(e) =>
                      setNewTeacher({ ...newTeacher, Role: e.target.value })
                    }
                  >
                    <option value="">Select Role</option>
                    <option value="special">Special Teacher</option>
                    <option value="principal">Principal Teacher</option>
                    <option value="class">Class Teacher</option>
                  </FormSelect>
                </FormGroup>
              </Col>
            </Row>
            <Button
              theme="success"
              className="submit_button"
              disabled={submitBtnState}
              onClick={() => createTeacher()}
            >
              Submit
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      <Modal open={resetModalVisible} toggle={resetPasswordModal}>
        <ModalHeader>Reset Password</ModalHeader>
        <ModalBody>
          <p className="text-center">Confirm Reset Password</p>
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => sendResetPasswordLink(resetEmail)}
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => resetPasswordModal("")}
            >
              Cancel
            </button>
          </div>
          {resetLoading && resetResponse !== "" && (
            <p className="text-center mt-2">{resetResponse}</p>
          )}
        </ModalBody>
      </Modal>
      <Modal open={schoolModalOpen} toggle={handleSchoolModalClose}>
        <ModalHeader>Add New School</ModalHeader>
        <ModalBody>
          <Form autoComplete="off">
            <FormGroup>
              <label htmlFor="#schoolName" className="mb-2">
                School Name
              </label>
              <FormInput
                id="#schoolName"
                placeholder="Enter School Name"
                value={newSchool.name}
                onChange={(e) => handleSchoolFormChange("name", e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="#city" className="mb-2">
                City
              </label>
              <FormInput
                id="#city"
                placeholder="Enter City"
                value={newSchool.city}
                onChange={(e) => handleSchoolFormChange("city", e.target.value)}
              />
            </FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSaveSchool}
              >
                Save School
              </button>
              <button
                type="button"
                className="btn btn-warning ml-2"
                onClick={handleSchoolModalClose}
              >
                Cancel
              </button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal open={classModalOpen} toggle={handleClassModalClose}>
        <ModalHeader>Add New Class</ModalHeader>
        <ModalBody>
          <Form autoComplete="off">
            <FormGroup>
              <label htmlFor="#className" className="mb-2">
                Class Name
              </label>
              <FormInput
                id="#className"
                placeholder="Enter Class Name"
                value={newClass.name}
                onChange={(e) => handleClassFormChange("name", e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="#selectSchool" className="mb-2">
                Select School
              </label>
              <FormSelect
                id="#selectSchool"
                value={newClass.schoolId}
                onChange={(e) =>
                  handleClassFormChange("schoolId", e.target.value)
                }
              >
                <option value="">Select a School</option>
                {schools.map((school) => (
                  <option key={school.id} value={school.id}>
                    {school.name}
                  </option>
                ))}
              </FormSelect>
            </FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSaveClass}
              >
                Save Class
              </button>
              <button
                type="button"
                className="btn btn-warning ml-2"
                onClick={handleClassModalClose}
              >
                Cancel
              </button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      {/* Optician Modal */}
      <Modal open={opticianModalVisible} toggle={addOpticianModal}>
        <ModalHeader>Add Optician</ModalHeader>
        <ModalBody>
          <Form autoComplete="off">
            <Row>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <label htmlFor="#opticianFirstName" className="mb-2">
                    First Name
                  </label>
                  <FormInput
                    id="#opticianFirstName"
                    placeholder="First Name"
                    type="text"
                    value={newOptician.FirstName}
                    onChange={(e) =>
                      setNewOptician({
                        ...newOptician,
                        FirstName: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <label htmlFor="#opticianLastName" className="mb-2">
                    Last Name
                  </label>
                  <FormInput
                    id="#opticianLastName"
                    placeholder="Last Name"
                    type="text"
                    value={newOptician.LastName}
                    onChange={(e) =>
                      setNewOptician({
                        ...newOptician,
                        LastName: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#opticianEmail" className="mb-2">
                    Email
                  </label>
                  <FormInput
                    id="#opticianEmail"
                    placeholder="Email"
                    type="email"
                    autoComplete="off"
                    value={newOptician.Email}
                    onChange={(e) =>
                      setNewOptician({ ...newOptician, Email: e.target.value })
                    }
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="12" sm="12">
                <FormGroup>
                  <label htmlFor="#opticianPhone" className="mb-2">
                    Mobile Number
                  </label>
                  <FormInput
                    id="#opticianPhone"
                    placeholder="Mobile Number"
                    type="text"
                    value={newOptician.PhoneNumber}
                    onChange={(e) =>
                      setNewOptician({
                        ...newOptician,
                        PhoneNumber: e.target.value,
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button
              theme="success"
              className="submit_button"
              disabled={submitBtnState}
              onClick={createOptician}
            >
              Submit
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </Container>
  );
}

export default SubAdmins;
